// extracted by mini-css-extract-plugin
module.exports = {"dev_alert":"DevStageAlert_dev_alert__uVa2d","dev_alert--margin":"DevStageAlert_dev_alert--margin__ZJATi","dev_alert__description":"DevStageAlert_dev_alert__description__am6bw"};